<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy,faPaste } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = true
    let bnakDep = {}
    let bakList = []
    let creditwd = ""
    let isbutton = true
    let mgpchannelType = "0"

    let mgpBKList //Corepay
    let mgpBKListMulti = []

    let isGatewayCorepay = false
    let isShowBank = true
    let isShowMulti = false
    let isShowSetzero = false
    let setzeroBank = null
    let setZeroBankId = ''

    let sectionBank = true
    let sectionWallet = true

    let bankBKList = []
    let walletBKList = []
    let autobank_type = ""
    let mybankIDs = ""

    let myBankBankList = []
    let myBankWalletList = []
    let myBankAllList = []
    let bankData2 = []
    let bankData3 = []
    let bankDataAll = []
    let names;

    let dataMember
    let isMember = false

    let scactive = {
        a:'active',
        b:'',
        c:'',
    }

    let multiPayment = 0
    let is_truewallet= 'C'
    async function getMember() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getmember", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            dataMember = json.payload
            is_truewallet = dataMember.dataGroup.is_truewallet
            // console.log(dataMember)
            isMember = true
		}
    }
    async function getBankdeposit() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbankdeposit", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            
            bakList = json.payload.lists
            autobank_type = json.payload.setting.autobank_type
            // names = bnakDep.bankaccountnumber
            for await (const iterator of json.payload.lists) {
                if(iterator.bank_code == 'truewallet'){
                    walletBKList.push(iterator)
                }
                if(iterator.bank_code == 'setzero'){
                    setzeroBank = iterator
                    isShowSetzero = true
                    isGatewayCorepay = false
                    isShowBank = false
                    setZeroBankId = iterator.id
                    continue
                }
                if(iterator.bank_code != 'truewallet' && iterator.bank_code != 'ezpay' && iterator.bank_code != 'spay' && iterator.bank_code != 'jpay' && iterator.bank_code != 'gonepay' && iterator.bank_code != 'p2w' && iterator.bank_code != 'cubixpay' && iterator.bank_code != 'gmpay24' && iterator.bank_code != 'setzero'){
                    bankBKList.push(iterator)
                }

                if((iterator.bank_code == 'ezpay' || iterator.bank_code == 'spay' || iterator.bank_code == 'jpay' || iterator.bank_code == 'gonepay' || iterator.bank_code == 'p2w' || iterator.bank_code == 'cubixpay' || iterator.bank_code == 'gmpay24') && iterator.auto == 'O'){
                    // isGateway = false
                    mgpBKList = iterator
                    mgpBKListMulti.push(iterator)
                    if(json.payload.setting.autobank_type=='A'){
                        isShowBank = false
                        isGatewayCorepay = true
                    }else{
                        isGatewayCorepay = true
                    }
                    multiPayment += 1
                }
            }
            // console.log('====CKBANK===')
            
            loading = false
		} else {

            throw new Error(json);
		}
    }
    async function getBank() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/memberbank", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            myBankAllList = json.payload
            for await (const iterator of json.payload) {
                let kk = {}
                if(iterator.bankcode=='truewallet'){
                    bankData2 = json.payload
                    myBankWalletList[iterator._id] = iterator.bankcode+" "+iterator.member_acc
                }else{
                    bankData3 = json.payload
                    myBankBankList[iterator._id] = iterator.bankcode+" "+iterator.member_acc
                    // bankDataAll[iterator._id] = iterator.bankcode+" "+iterator.member_acc
                }

                bankDataAll[iterator._id] = iterator.bankcode+" "+iterator.member_acc
                
                
                //bankList.push(kk)
            }
		}
    }
    async function selectBankWithdrawCorePAY() {
        if(Number(creditwd)<dataMember.dataGroup.min_deposit){
            Swal.fire({
                    heightAuto: false,
                    title: 'กรุณาฝากขั้นต่ำ '+dataMember.dataGroup.min_deposit+' บาท',
                    text: "",
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            return
        }
        isbutton = false
        mybankIDs = ""
        let vBank = []
        
        vBank = bankDataAll 

        // alert(multiPayment)

        if(bankDataAll.length==1){
            mybankIDs = bankDataAll[0].id
            if(Number(creditwd)<50 && bankDataAll[0].bank_code == 'gpay'){
                Swal.fire({
                        heightAuto: false,
                        title: 'กรุณาฝากขั้นต่ำ 50 บาท',
                        text: "",
                        icon: 'error',
                        confirmButtonText: 'OK' 
                    })
                return
            }
            if(Number(creditwd)<20 && bankDataAll[0].bank_code == 'gpayfp'){
                Swal.fire({
                        heightAuto: false,
                        title: 'กรุณาฝากขั้นต่ำ 20 บาท',
                        text: "",
                        icon: 'error',
                        confirmButtonText: 'OK' 
                    })
                return
            }
            if(Number(creditwd)<100 && bankDataAll[0].bank_code == 'gonepay'){
                Swal.fire({
                        heightAuto: false,
                        title: 'กรุณาฝากขั้นต่ำ 100 บาท',
                        text: "",
                        icon: 'error',
                        confirmButtonText: 'OK' 
                    })
                return
            }
            checkMultiPayment()
        }else{
            const { value: fruit } = await Swal.fire({
                title: 'เลือกบัญชีที่ใช้ฝาก',
                input: 'select',
                inputOptions: vBank,
                inputPlaceholder: 'เลือกบัญชีที่ใช้ฝาก',
                showCancelButton: true,
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        resolve() 
                    })
                }
            })
            //console.log(fruit)
            if (fruit) {
                // console.log(fruit)
                mybankIDs = fruit
                let goWallet = false
                for await (const iterator of myBankAllList) {
                    if(iterator._id==fruit && iterator.bankcode=='truewallet'){
                        goWallet = true
                        scactive = {
                            a:'',
                            b:'active',
                            c:'',
                        }
                    }
                }
                if(goWallet){
                    isGatewayCorepay = false
                    isShowBank = true
                    sectionBank = false
                    sectionWallet = true
                    isbutton = true
                }else{
                    if(multiPayment>=2){
                        let delGpay = false
                        let delGpayfp = false
                        for await (const element of mgpBKListMulti) {
                            if(element.bank_code=='gpay' && Number(creditwd)<50 ){
                                delGpay = true
                            }
                            if(element.bank_code=='gpayfp' && Number(creditwd)<20 ){
                                delGpayfp = true
                            }
                        }
                        if(delGpay && delGpayfp){
                            isGatewayCorepay = false
                            isShowBank = true
                            sectionBank = true
                            sectionWallet = false
                            isbutton = true
                            return
                        }
                        if(delGpay && !delGpayfp){
                            getSECPAYQRScan2()
                            return
                        }
                        if(delGpay && !delGpayfp){
                            getSECPAYQRScan()
                            return
                        }
                        checkMultiPayment()
                    }else{
                        if(mgpBKList.bank_code=='gpay' && Number(creditwd)<50 ){
                            isGatewayCorepay = false
                            isShowBank = true
                            sectionBank = true
                            sectionWallet = false
                            isbutton = true
                        }
                        else if(mgpBKList.bank_code=='gpayfp' && Number(creditwd)<5 ){
                            isGatewayCorepay = false
                            isShowBank = true
                            sectionBank = true
                            sectionWallet = false
                            isbutton = true
                        }else{
                            checkMultiPayment()
                        }
                    }
                    
                }
                // 
            }else{
                Swal.fire(`เลือกบัญชีที่ใช้ฝาก`)
                isbutton = true
            }
        }
    }
    async function checkMultiPayment() {
        if(multiPayment>=2){
            isGatewayCorepay = false
            isShowBank = false
            isShowMulti = true
        }else{
            if(mgpBKList.bank_code=='gpay'){
                getSECPAYQRScan()
            }else{
                getSECPAYQRScan2()
            }
            
        }
    }
    async function getSECPAYQRScan() {
        let bankMm
        for await (const element of mgpBKListMulti) {
            if(element.bank_code == 'gpay'){
                bankMm = element
            }
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/corepayqrcode", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                bankid:bankMm.id,
                credit:parseInt(creditwd),
                member_acc:mybankIDs,
                channleType:mgpchannelType,
                play_url:dataSetting.member_url+"/#/history"
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            if(bankMm.bank_code=='gpay'){
                push('/gpay/'+json.payload.txn)
            }
            else if(bankMm.bank_code=='ezpay'){
                push('/ezpay/'+json.payload.txn)
            }
            else if(bankMm.bank_code=='p2w'){
                push('/p2w/'+json.payload.txn)
            }
            else if(bankMm.bank_code=='spay'){
                push('/spay/'+json.payload.txn)
            }else{
                window.open(json.payload.url)
                push('/history')
            }
            
		} 
        else if(json.statusCode==202){
            // isShowBank = true
            // isGateway = false
            isbutton = true
            Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: json.message,
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
        }else {
            Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: "กรุณาติดต่อเจ้าหน้าที่",
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            isbutton = true
            throw new Error(json);
		}
    }
    async function getSECPAYQRScan2() {
        let bankMm
        let notredirect = false
        for await (const element of mgpBKListMulti) {
            if(element.bank_code == 'gpayfp'){
                bankMm = element
            }
            if(element.bank_code == 'ezpay'){
                bankMm = element
            }
            if(element.bank_code == 'spay'){
                bankMm = element
            }
            if(element.bank_code == 'jpay'){
                bankMm = element
            }
            if(element.bank_code == 'cubixpay'){
                bankMm = element
            }
            if(element.bank_code == 'gmpay24'){
                bankMm = element
            }
            if(element.bank_code == 'gonepay'){
                bankMm = element
                // if(Number(creditwd)<100 ){
                //     isGatewayCorepay = false
                //     isShowBank = true
                //     sectionBank = true
                //     sectionWallet = false
                //     isShowMulti = false
                //     isbutton = true
                //     notredirect = true
                // }
            }
            if(element.bank_code == 'p2w'){
                bankMm = element
                // if(Number(creditwd)<100 ){
                //     isGatewayCorepay = false
                //     isShowBank = true
                //     sectionBank = true
                //     sectionWallet = false
                //     isShowMulti = false
                //     isbutton = true
                //     notredirect = true
                // }
            }
        }
        if(notredirect){
            return
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/corepayqrcode", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                bankid:bankMm.id,
                credit:parseInt(creditwd),
                member_acc:mybankIDs,
                channleType:mgpchannelType,
                play_url:dataSetting.member_url+"/#/history"
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            if(bankMm.bank_code=='ezpay'){
                push('/ezpay/'+json.payload.txn)
            }
            else if(bankMm.bank_code=='p2w'){
                if(json.payload.bankcode=='p2w'){
                    push('/p2w/'+json.payload.txn)
                }
                else if(json.payload.bankcode=='ezpay'){
                    push('/ezpay/'+json.payload.txn)
                }else{
                    window.open(json.payload.slip_url,'_blank')
                    Swal.fire({
                        html: `
                            <h5>หากระบบไม่เปิด หน้าชำระเงิน กรุณาคลิกที่ปุ่มด้านล่าง</h5><br />
                            <a  href="${json.payload.slip_url}" target="_blank" class="btn btn-warning btn-lg">ไปหน้าชำระเงิน</a>
                        `,
                        showCloseButton: true,
                        showCancelButton: false,
                        showConfirmButton:false,
                        focusConfirm: false
                    });
                    push('/history')
                }
            }
            else if(bankMm.bank_code=='gmpay24'){
                if(json.payload.bankcode=='gmpay24'){
                    push('/gmpay24/'+json.payload.txn)
                }else{
                    window.open(json.payload.slip_url,'_blank')
                    Swal.fire({
                        html: `
                            <h5>หากระบบไม่เปิด หน้าชำระเงิน กรุณาคลิกที่ปุ่มด้านล่าง</h5><br />
                            <a  href="${json.payload.slip_url}" target="_blank" class="btn btn-warning btn-lg">ไปหน้าชำระเงิน</a>
                        `,
                        showCloseButton: true,
                        showCancelButton: false,
                        showConfirmButton:false,
                        focusConfirm: false
                    });
                    push('/history')
                }
            }
            else if(bankMm.bank_code=='cubixpay'){
                if(json.payload.bankcode=='cubixpay'){
                    window.open(json.payload.slip_url,'_blank')
                    Swal.fire({
                        html: `
                            <h5>หากระบบไม่เปิด หน้าชำระเงิน กรุณาคลิกที่ปุ่มด้านล่าง</h5><br />
                            <a  href="${json.payload.slip_url}" target="_blank" class="btn btn-warning btn-lg">ไปหน้าชำระเงิน</a>
                        `,
                        showCloseButton: true,
                        showCancelButton: false,
                        showConfirmButton:false,
                        focusConfirm: false
                    });
                    push('/history')
                }
                else if(json.payload.bankcode=='gmpay24'){
                    push('/gmpay24/'+json.payload.txn)
                }else{
                    window.open(json.payload.slip_url,'_blank')
                    Swal.fire({
                        html: `
                            <h5>หากระบบไม่เปิด หน้าชำระเงิน กรุณาคลิกที่ปุ่มด้านล่าง</h5><br />
                            <a  href="${json.payload.slip_url}" target="_blank" class="btn btn-warning btn-lg">ไปหน้าชำระเงิน</a>
                        `,
                        showCloseButton: true,
                        showCancelButton: false,
                        showConfirmButton:false,
                        focusConfirm: false
                    });
                    push('/history')
                }
                
            }
            else if(bankMm.bank_code=='jpay' || bankMm.bank_code=='gonepay'){
                window.open(json.payload.slip_url,'_blank')
                Swal.fire({
                    html: `
                        <h5>หากระบบไม่เปิด หน้าชำระเงิน กรุณาคลิกที่ปุ่มด้านล่าง</h5><br />
                        <a  href="${json.payload.slip_url}" target="_blank" class="btn btn-warning btn-lg">ไปหน้าชำระเงิน</a>
                    `,
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton:false,
                    focusConfirm: false
                });
                // window.location = json.payload.slip_url
                push('/history')
            }else{
                push('/spay/'+json.payload.txn)
            }
            
            
		} 
        else if(json.statusCode==202){
            // isShowBank = true
            // isGateway = false
            isbutton = true
            if(bankMm.bank_code=='jpay'){
                Swal.fire({
                    heightAuto: false,
                    title: 'คุณมีรายการที่รอการชำระเงิน',
                    text: 'หากต้องการเปลี่ยนแปลงยอดกรุณา ยกเลิกรายการ ก่อนหน้าก่อนทำรายการใหม่',
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
                push('/history')
            }else{
                Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: json.message,
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            }
            
        }else {
            Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: "กรุณาติดต่อเจ้าหน้าที่",
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            isbutton = true
            throw new Error(json);
		}
    }
    let textarea;
	async function copyNumber(){
		textarea.select();
		document.execCommand('copy');
	}
    getMember()
    getBankdeposit()
    getBank()

    

    
    async function selectCh(ids){
		if(ids == 1){
            scactive = {
                a:'active',
                b:'',
                c:'',
            }
        }
        if(ids == 2){
            scactive = {
                a:'',
                b:'active',
                c:'',
            }
        }
        if(ids == 3){
            scactive = {
                a:'',
                b:'',
                c:'active',
            }
        }
	}

</script>
<div class="default-home">
<div class="row  mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    <div class="col-12 text-center mt-2" style="padding-left:10px;padding-right:10px;" >
        <h4 class="header-n">เลือกช่องทางฝากเงิน</h4>
    </div>
    <div class="col-12 text-center mt-2" style="padding-right:5px;padding-left:10px;">
        <div class="card mt-0 bg-black">
            <div class="card-body text-center">
                <div class="row text-white">
                    <div class="col-4 mb-2 blox-acc {scactive.a}" on:click={() => selectCh(1)}>
                        <span>บัญชีธนาคาร</span>
                        <div class="box-select-ch mt-2">
                            
                            <img src="./assets/icon/bankacc-n.png" class="img-fluid" alt="bak account">
                        </div>
                    </div>
                    {#if is_truewallet=='O'}
                    <div class="col-4 mb-2 blox-acc {scactive.b}" on:click={() => selectCh(2)}>
                        <span>ทรูวอลเล็ท</span>
                        <div class="box-select-ch mt-2">
                            
                            <img src="./assets/icon/twalletacc.png" class="img-fluid" alt="truewallet account">
                        </div>
                    </div>
                    {/if}
                </div>
            </div>
        </div>
        
    </div>
    {#if loading}
    <div class="text-center mt-2" style="">
        <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
    </div>
    {/if}
    {#if !loading}

    {#if scactive.a =='active'}
    <div class="col-12 pb-5 mt-2" style="min-height: 500px;padding-left:5px;padding-right:10px;">
        <div class="card mt-0 bg-xgrey">
            <div class="card-body text-center">

                {#if isGatewayCorepay}
                <div class="card mt-2 bg-black">
                    
                    <div class="card-body text-center pb-1">
                        
                        <div class="row">
                            <div class="col-4"></div>
                            <div class="col-4 mb-2">
                                <img src="./assets/images/paynow.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="creditwd" class="form-label text-warning">กรอกจำนวนเงินที่ต้องการฝาก</label>
                            <input type="text" class="form-control rounded-pill text-center mb-1" id="creditwd" placeholder="ระบุยอดที่ต้องการฝาก" bind:value={creditwd}>
                            {#if isMember}
                                <small class="text-white">ฝากขั้นต่ำ <span class="text-danger">{dataMember.dataGroup.min_deposit}</span> บาท</small>
                            {/if}
                        </div>
                        <div class="row">
                            {#if isbutton}
                            <div class="col-12 text-center d-grid gap-2"> 
                                <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => selectBankWithdrawCorePAY()}>ยืนยันฝากเงิน</button><br />
                            </div>
                            {:else}
                            <div class="col-12 text-center">
                                <Fa icon={faSpinner} size="2x" pulse class="text-white"/>
                            </div>
                            {/if}
                        </div>
                        
                    </div>
                </div>
                {/if}

                {#if isShowBank}
                {#if sectionBank}
                {#each bankBKList as item}
                <div class="card mt-1 bg-black">
                    <div class="card-body text-center">
                        <img src="./build/images/bank/{item.bank_code}.png" class="img-fluid" style="max-width: 30%;">
                        <h6 class="mt-4 text-warning">{item.bank_accname}</h6>
                        <h6 class="text-white">{item.bank_name}</h6>
                        <h5 class="mb-2 text-white">{item.bank_acc} 
                            
                            <Clipboard
                            text= {item.bank_acc}
                            let:copy
                            on:copy={() => {
                                console.log('Has Copied');
                                Swal.fire(`คัดลอกแล้ว`)
                            }}>
                            <br/><button type="button" class="btn-copys" on:click={copy}>คัดลอกเลขบัญชี</button>
                            </Clipboard>
                        
                        </h5>
                        <div class="blog-dng">
                            กรุณาใช้เลขบัญชีที่สมัครโอนเข้ามาเท่านั้น
                        </div>
                        
                    </div>
                </div>
                {/each}
                {/if}
                {/if}

                {#if isShowMulti}
                <div class="row">
                    <div class="col-12 pt-2">
                        <h6 class="text-warning">เลือกวิธีการโอนเงิน</h6>
                    </div>
                    <div class="col-6 p-2">
                        <div class="card mt-1 bg-black "  on:click={() => getSECPAYQRScan2()}>
                            <img src="./assets/icon/banknumber.png" class="img-fluid box-select-ch" alt="bak account" style="border-radius: 5px;">
                        </div>
                    </div>
                    <div class="col-6 p-2" on:click={() => getSECPAYQRScan()}>
                        <div class="card mt-1 bg-black">
                            <img src="./assets/icon/promptpay.png" class="img-fluid box-select-ch" alt="promptpay" style="border-radius: 5px;">
                        </div>
                    </div>
                    <div class="col-6 p-2">
                        <h6 class="text-white" on:click={() => getSECPAYQRScan2()}>บัญชีธนาคาร</h6>
                    </div>
                    <div class="col-6 p-2">
                        <h6 class="text-white" on:click={() => getSECPAYQRScan()}>คิวอาร์โค้ด</h6>
                    </div>
                </div>
                {/if}

                {#if isShowSetzero}
                <div class="card mt-3 bg-black">
                        <div class="card-body text-center py-5">
                            <h5 class="text-warning mb-4">ฝากเงินผ่านระบบอัตโนมัติ</h5>
                            <a href="#/setzero/{setZeroBankId}" target="_blank" rel="noopener noreferrer" class="btn btn-dark rounded-pill btn-gd px-4 text-white">ไปหน้าฝากเงิน</a>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </div>
    {/if}

    {#if scactive.b =='active'}
    <div class="col-12 pb-5 mt-2" style="min-height: 500px;padding-left:5px;padding-right:10px;">
        <div class="card mt-0 bg-xgrey">
            <div class="card-body text-center">
                {#each walletBKList as item}
                <div class="card mt-1 bg-black">
                    <div class="card-body text-center">
                        <img src="./build/images/bank/{item.bank_code}.png" class="img-fluid" style="max-width: 30%;">
                        <h6 class="mt-4 text-warning">{item.bank_accname}</h6>
                        <h6 class="text-white">{item.bank_name}</h6>
                    
                        <h5 class="mb-2 text-white">{item.bank_acc} 
                            <Clipboard
                            text= {item.bank_acc}
                            let:copy
                            on:copy={() => {
                                console.log('Has Copied');
                                Swal.fire(`คัดลอกแล้ว`)
                            }}>
                            <br/><button type="button" class="btn-copys" on:click={copy}>คัดลอกเลขบัญชี</button>
                            </Clipboard>
                        
                        </h5>
                        <div class="blog-dng">
                            กรุณาใช้เลขบัญชีที่สมัครโอนเข้ามาเท่านั้น
                        </div>
                        
                    </div>
                </div>
                {/each}
            </div>
        </div>
    </div>
    {/if}

    {#if scactive.c =='active'}
    <div class="col-12 pb-5 mt-2" style="min-height: 500px;padding-left:5px;padding-right:10px;">
        <div class="card mt-0 bg-xgrey">
            <div class="card-body text-center text-white">
                <h6>กรุณาติดต่อเจ้าหน้าที่เพื่อสอบถามข้อมูล</h6>
            </div>
        </div>
    </div>
    {/if}

    {/if}
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-deposits">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4  class="head-title ">เลือกช่องทางการฝากเงิน</h4></div>
        <div class="col-12 text-center mt-3" >
            <div class="card mt-0 bg-black">
                <div class="card-body text-center">
                    <div class="row text-white">
                        <div class="col-4 {scactive.a}" on:click={() => selectCh(1)}>
                            <span>บัญชีธนาคาร</span>
                            <div class="box-select-ch mt-2">
                                
                                <img src="./assets/icon/bankacc-n.png" class="img-fluid" alt="bak account">
                            </div>
                        </div>
                        <div class="col-4 {scactive.b}" on:click={() => selectCh(2)}>
                            <span>ทรูวอลเล็ท</span>
                            <div class="box-select-ch mt-2">
                                
                                <img src="./assets/icon/twalletacc.png" class="img-fluid" alt="truewallet account">
                            </div>
                        </div>
                        <div class="col-4 {scactive.c}"  on:click={() => selectCh(3)}>
                            <span>เงินดิจิทัล</span>
                            <div class="box-select-ch mt-2">
                                
                                <img src="./assets/icon/cryptoacc.png" class="img-fluid" alt="crypto currency account">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
    
        {#if scactive.a =='active'}
        <div class="col-12 pb-5 mt-3" style="min-height: 500px">
            <div class="card mt-0 bg-xgrey">
                <div class="card-body text-center">
    
                    {#if isGatewayCorepay}
                    <div class="card mt-2 bg-black">
                        <div class="card-body text-center pb-1">
                            <div class="row">
                                <div class="col-4"></div>
                                <div class="col-4 mb-2">
                                    <img src="./assets/icon/promptpay.png" class="img-fluid" alt="promptpay" style="border-radius: 10px;">
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="creditwd" class="form-label text-warning">กรอกจำนวนเงินที่ต้องการฝาก</label>
                                <input type="text" class="form-control rounded-pill text-center mb-1" id="creditwd" placeholder="ระบุยอดที่ต้องการฝาก" bind:value={creditwd}>
                                {#if isMember}
                                    <small class="text-white">ฝากขั้นต่ำ <span class="text-danger">{dataMember.dataGroup.min_deposit}</span> บาท</small>
                                {/if}
                            </div>
                            <div class="row">
                                {#if isbutton}
                                <div class="col-12 text-center d-grid gap-2"> 
                                    <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => selectBankWithdrawCorePAY()}>ยืนยันฝากเงิน</button><br />
                                </div>
                                {:else}
                                <div class="col-12 text-center">
                                    <Fa icon={faSpinner} size="2x" pulse class="text-white"/>
                                </div>
                                {/if}
                            </div>
                            
                        </div>
                    </div>
                    {/if}
    
                    {#if isShowBank}
                    {#if sectionBank}
                    {#each bankBKList as item}
                    <div class="card mt-3 bg-black">
                        <div class="card-body text-center">
                            <img src="./build/images/bank/{item.bank_code}.png" class="img-fluid" style="max-width: 30%;">
                            <h6 class="mt-4 text-warning">{item.bank_accname}</h6>
                            <h6 class="text-white">{item.bank_name}</h6>
                            <h5 class="mb-4 text-white">{item.bank_acc} 
                                
                                <Clipboard
                                text= {item.bank_acc}
                                let:copy
                                on:copy={() => {
                                    console.log('Has Copied');
                                    Swal.fire(`คัดลอกแล้ว`)
                                }}>
                                <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1x"  pulse class="text-info " /></span>
                                </Clipboard>
                            
                            </h5>
                            <small class="text-info ">กดคัดลอกหมายเลขบัญขี แล้วโอนเงิน รอเครดิตเข้าไม่เกิน 30 วินาที</small>
                            
                        </div>
                    </div>
                    {/each}
                    {/if}
                    {/if}

                    {#if isShowMulti}
                    <div class="row">
                        <div class="col-12 pt-2">
                            <h6 class="text-warning">เลือกวิธีการโอนเงิน</h6>
                        </div>
                        <div class="col-6 p-2">
                            <div class="card mt-3 bg-black "  on:click={() => getSECPAYQRScan2()}>
                                <img src="./assets/icon/banknumber.png" class="img-fluid box-select-ch" alt="bak account" style="border-radius: 5px;">
                            </div>
                        </div>
                        <div class="col-6 p-2" on:click={() => getSECPAYQRScan()}>
                            <div class="card mt-3 bg-black">
                                <img src="./assets/icon/promptpay.png" class="img-fluid box-select-ch" alt="promptpay" style="border-radius: 5px;">
                            </div>
                        </div>
                        <div class="col-6 p-2">
                            <h6 class="text-white" on:click={() => getSECPAYQRScan2()}>บัญชีธนาคาร</h6>
                        </div>
                        <div class="col-6 p-2">
                            <h6 class="text-white" on:click={() => getSECPAYQRScan()}>คิวอาร์โค้ด</h6>
                        </div>
                    </div>
                    {/if}

                    {#if isShowSetzero}
                    <div class="card mt-3 bg-black">
                        <div class="card-body text-center py-5">
                            <h5 class="text-warning mb-4">ฝากเงินผ่านระบบอัตโนมัติ</h5>
                            <a href="#/setzero/{setZeroBankId}" target="_blank" rel="noopener noreferrer" class="btn btn-dark rounded-pill btn-gd px-4 text-white">ไปหน้าฝากเงิน</a>
                        </div>
                    </div>
                    {/if}

                </div>
            </div>
        </div>
        {/if}
    
        {#if scactive.b =='active'}
        <div class="col-12 pb-5 mt-3" style="min-height: 500px">
            <div class="card mt-0 bg-xgrey">
                <div class="card-body text-center">
                    {#each walletBKList as item}
                    <div class="card mt-2 bg-black">
                        <div class="card-body text-center">
                            <img src="./build/images/bank/{item.bank_code}.png" class="img-fluid" style="max-width: 30%;">
                            <h6 class="mt-4 text-warning">{item.bank_accname}</h6>
                            <h6 class="text-white">{item.bank_name}</h6>
                        
                            <h5 class="mb-4 text-white">{item.bank_acc} 
                                <Clipboard
                                text= {item.bank_acc}
                                let:copy
                                on:copy={() => {
                                    console.log('Has Copied');
                                    Swal.fire(`คัดลอกแล้ว`)
                                }}>
                                <span class="pointer" on:click={copy}><Fa icon={faCopy} size="1x"  pulse class="text-info " /></span>
                                </Clipboard>
                            
                            </h5>
                            <small class="text-info ">กดคัดลอกหมายเลขบัญขี แล้วโอนเงิน รอเครดิตเข้าไม่เกิน 30 วินาที</small>
                            
                        </div>
                    </div>
                    {/each}
                </div>
            </div>
        </div>
        {/if}
    
        {#if scactive.c =='active'}
        <div class="col-12 pb-5 mt-3" style="min-height: 500px">
            <div class="card mt-0 bg-xgrey">
                <div class="card-body text-center text-white">
                    <h6>กรุณาติดต่อเจ้าหน้าที่เพื่อสอบถามข้อมูล</h6>
                </div>
            </div>
        </div>
        {/if}
    
        {/if}
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">

</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .blox-acc{
        border: 1px solid #5a5a5a85;
        padding: 2px 10px 7px 10px;
        border-radius: 15px;
    }
    .blox-acc:last-child{
        margin-left: 10px;
    }
    .btn-copys{
        padding: 4px 2px;
        font-size: .90rem;
        margin-top: 8px;
        padding: 5px 10px 5px 10px;
        font-weight: 400;
        color: #262626;
        background: #f9d62e;
        border-radius: 15px;
        line-height: unset;
        position: relative;
        top: -4px;
        border: 0px;
    }
    .blog-dng{
        font-size: 0.7rem !important;
        background: red;
        padding: 10px;
        color: #eb5757;
        background: #370e0e;
        border: 1px solid #eb5757;
        border-radius: 5px;
        text-align: center;
    }
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .bg-black{
        background: #000000ad !important;
    }
    .box-select-ch{
        border: 1px solid grey;
        border-radius: 10%;
        cursor: pointer;
        border-radius: 50px;
        padding: 10px;
    }
    .box-select-ch:hover{
        /* border: 2px solid gold; */
        box-shadow: 0px 0px 10px 3px gold;
        box-shadow: 0px 0px 10px 3px #089b57;
    }
    .active .box-select-ch{
        border: 1px solid gold;
        box-shadow: 0px 0px 10px 3px gold;
        border: 1px solid #00d171;
        box-shadow: 0px 0px 10px 3px #089b57;
    }
    .active {
        color: gold;
    }
    .default-home .card-body{
        padding: 5px;
    }
    .box-select-ch img{
        border-radius: 50px;
    }
</style>
